import { createContext } from 'react';

export type FavoriteProductsContextType = {
  modifyFavoriteProducts: (sku: string) => void;
  productIds: string[];
};

export const favoriteProductsContext =
  createContext<FavoriteProductsContextType | null>(null);
